import { render, staticRenderFns } from "./cwbsckDetail.vue?vue&type=template&id=6841091c&scoped=true"
import script from "./cwbsckDetail.vue?vue&type=script&lang=js"
export * from "./cwbsckDetail.vue?vue&type=script&lang=js"
import style0 from "./cwbsckDetail.vue?vue&type=style&index=0&id=6841091c&prod&scoped=true&lang=css"
import style1 from "./cwbsckDetail.vue?vue&type=style&index=1&id=6841091c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6841091c",
  null
  
)

export default component.exports